import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import MyButton from '../../../../UI/form/MyButton'
import { useNavigate } from 'react-router-dom'
import { setIsAuth, setUser } from '../../../../../store/userSlice'
import { useState } from 'react'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { logoutAPI } from '../../../../../api/user/userAPI'

const UserLogoutForm = () => {

    const user = useSelector(state => state.user.user)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [error, setError] = useState('')

    const logout = () => {
        logoutAPI().then(data => {
			localStorage.removeItem('token')
			dispatch(setUser({}))
			dispatch(setIsAuth(false))
            navigate('/login')
		}).catch(e => {
            setError(responseError(e))
        })
    }

  return (
    <div>
        <p>Ви впевнені, що хочете вийти з облікового запису?</p>

        {
            error ?
                <div className='error'>
                    {error}
                </div>
            : ''
        }

        <MyButton
            color='red'
            size='md'
            onClick={logout}
        >
            Вийти
        </MyButton>
    </div>
  )
}

export default UserLogoutForm